import axios from 'axios';
import { PIPELINE_ID_SESSION_KEY, RULESET_ID_SESSION_KEY } from '../utils/constants';

let url = '';

export function initRuleSetService(config: Record<string, any>) {
    url = config.rulesUrl;
}

export const getRuleSets = async () => {
    const res = await axios.get<RuleSets>(`${url}/ruleSets/tenant`);
    return res.data;
};

/**
 * The User Rule Set ID is crucial for the App. The value is stored in the session storage.
 * Use the following code snippet to get the current User Rule Set ID:
 * @example sessionStorage.getItem(RULESET_ID_SESSION_KEY);
 */
export const setUserRuleSetId = async (): Promise<void> => {
    if (!sessionStorage.getItem(RULESET_ID_SESSION_KEY)) {
        const ruleSets: RuleSets = await getRuleSets();
        if (Array.isArray(ruleSets) && ruleSets?.length > 0) {
            sessionStorage.setItem(RULESET_ID_SESSION_KEY, String(ruleSets[0].id));
            sessionStorage.setItem(PIPELINE_ID_SESSION_KEY, ruleSets[0].pipelineId);
        }
    } else {
        sessionStorage.getItem(RULESET_ID_SESSION_KEY);
    }
};

export const replaceUserRuleSetId = (ruleSet: RuleSet) => {
    sessionStorage.setItem(RULESET_ID_SESSION_KEY, String(ruleSet.id));
    sessionStorage.setItem(PIPELINE_ID_SESSION_KEY, ruleSet.pipelineId);
};
